import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { MainLayout } from './components/layout';
import { LoadingFallback, ToastContainer } from './components/common';

// Lazy load pages for better performance
const Overview = lazy(() => import('./pages/Overview').then(m => ({ default: m.Overview })));
const ArbiterChallenges = lazy(() => import('./pages/ArbiterChallenges').then(m => ({ default: m.ArbiterChallenges })));
const ActionsEscalations = lazy(() => import('./pages/ActionsEscalations').then(m => ({ default: m.ActionsEscalations })));
const CommitteePack = lazy(() => import('./pages/CommitteePack').then(m => ({ default: m.CommitteePack })));
const FinancialPlanning = lazy(() => import('./pages/FinancialPlanning').then(m => ({ default: m.FinancialPlanning })));
const TreasuryLiquidity = lazy(() => import('./pages/TreasuryLiquidity').then(m => ({ default: m.TreasuryLiquidity })));
const CapitalManagement = lazy(() => import('./pages/CapitalManagement').then(m => ({ default: m.CapitalManagement })));
const FinancialReporting = lazy(() => import('./pages/FinancialReporting').then(m => ({ default: m.FinancialReporting })));
const InvestorRelations = lazy(() => import('./pages/InvestorRelations').then(m => ({ default: m.InvestorRelations })));
const CostManagement = lazy(() => import('./pages/CostManagement').then(m => ({ default: m.CostManagement })));
const NotFound = lazy(() => import('./pages/NotFound').then(m => ({ default: m.NotFound })));

function App() {
  return (
    <BrowserRouter>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Navigate to="/cfo/overview" replace />} />
        <Route path="/cfo" element={<MainLayout />}>
          <Route
            path="overview"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <Overview />
              </Suspense>
            }
          />
          <Route
            path="arbiter-challenges"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <ArbiterChallenges />
              </Suspense>
            }
          />
          <Route
            path="actions-escalations"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <ActionsEscalations />
              </Suspense>
            }
          />
          <Route
            path="committee-pack"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <CommitteePack />
              </Suspense>
            }
          />
          <Route
            path="financial-planning"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <FinancialPlanning />
              </Suspense>
            }
          />
          <Route
            path="treasury-liquidity"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <TreasuryLiquidity />
              </Suspense>
            }
          />
          <Route
            path="capital-management"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <CapitalManagement />
              </Suspense>
            }
          />
          <Route
            path="financial-reporting"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <FinancialReporting />
              </Suspense>
            }
          />
          <Route
            path="investor-relations"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <InvestorRelations />
              </Suspense>
            }
          />
          <Route
            path="cost-management"
            element={
              <Suspense fallback={<LoadingFallback />}>
                <CostManagement />
              </Suspense>
            }
          />
        </Route>
        <Route
          path="*"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <NotFound />
            </Suspense>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
